import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-argus-power-bi',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './argus-power-bi.component.html',
  styleUrl: './argus-power-bi.component.scss'
})
export class ArgusPowerBiComponent {

}
